import config from 'config';

export const logIt = (type, ...args) => {
  if (config?.allowConsoles) {
    console.log(type, ':', ...args);
  }
};
